var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "bg-gray2" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row swiper-1row d-xl-none py-2 mt-2" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", {
              staticClass: "no-signature",
              domProps: { innerHTML: _vm._s(_vm.title) },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "ob1-carrousel swiper-container reco-mobiles-swiper-container",
              },
              [
                _c(
                  "div",
                  { staticClass: "swiper-wrapper" },
                  _vm._l(_vm.mobiles, function (mobile, index) {
                    return _c(
                      "div",
                      {
                        key: "reco" + mobile.seoId.value,
                        staticClass: "swiper-slide",
                      },
                      [
                        _c("reco-mobile", {
                          attrs: {
                            mobile: mobile,
                            index: index + 1,
                            "data-pdb-zid": _vm.dataPdbZid,
                            "advantage-messages": _vm.advantageMessages,
                            "funding-details-dto": _vm.fundingDetailsDto,
                          },
                          on: {
                            fundingDetailsClick: _vm.handleFundingDetailsClick,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-none d-xl-block py-2 mt-2 grid-4col" },
          [
            _c("h2", {
              staticClass: "no-signature",
              domProps: { innerHTML: _vm._s(_vm.title) },
            }),
            _vm._v(" "),
            _vm._l(_vm.numberOfRows(4), function (y) {
              return _c(
                "div",
                { key: "reco" + y, staticClass: "row" },
                _vm._l(4, function (x) {
                  return _c(
                    "div",
                    { key: "reco" + x, staticClass: "col-3" },
                    [
                      _vm.mobileAt(x, y, 4)
                        ? _c("reco-mobile", {
                            attrs: {
                              mobile: _vm.mobileAt(x, y, 4),
                              index: x,
                              "data-pdb-zid": _vm.dataPdbZid,
                              "advantage-messages": _vm.advantageMessages,
                              "funding-details-dto": _vm.fundingDetailsDto,
                            },
                            on: {
                              fundingDetailsClick:
                                _vm.handleFundingDetailsClick,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.linkUrl && _vm.linkLabel
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center pb-1 mb-3" },
            [
              _c("ob1-liens", {
                attrs: {
                  text: _vm.linkLabel,
                  href: _vm.linkUrl,
                  "with-arrow": "",
                  "data-oevent-category": "marchand_eqpt",
                  "data-oevent-action": "voir-tous-les-mobiles",
                  "data-oevent-label": _vm.linkUrl,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.subTitle
      ? _c(
          "div",
          { staticClass: "container-fluid mt-3 d-webview-none" },
          [
            _vm.shop === "ORANGE"
              ? [_c("h2", { domProps: { innerHTML: _vm._s(_vm.subTitle) } })]
              : [_c("header-signature", { attrs: { text: _vm.subTitle } })],
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "d-block swiper-button-prev",
        attrs: { id: "swiper-button-prev", title: "Précédent" },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Précédent")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "d-block swiper-button-next",
        attrs: { id: "slide-next-button", title: "Suivant" },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Suivant")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }